import React__default from 'react';
import '../../constants/authorizedUsers.js';
import '../../constants/bidStatus.js';
import '../../constants/bulkLoadCardStatus.js';
import { FONT_WEIGHTS } from '../../constants/misc.js';
import '../../constants/event-names.js';
import '../../constants/eventsMapObj.js';
import '../../constants/Faq.js';
import '../../constants/languages.js';
import '../../constants/loadStatus.js';
import '../../constants/lorryStatus.js';
import '../../constants/lorryTypes.js';
import '../../constants/mostSearchedLinks.js';
import '../../constants/Pages.js';
import { getRemValue } from '../../methods/getRemValue.js';
import { getHeightByViewPort } from '../../methods/getSizeByViewPort.js';
import 'bowser';
import '../../_virtual/_tslib.js';
import '../toast/toast.js';
import '../../_services/auth.service.js';
import '../../methods/getAuthIdParam.js';
import 'react-cookie';
import '../../methods/formatDate.js';
import '../../constants/StateList.js';
import '../../methods/getTransporterFigure.js';
import '../../methods/getDownloadsFigure.js';
import 'lodash.isequal';
import '../../methods/getPageLoadSourceUTMParam.js';
import 'crypto-js';
import '../../constants/serviceTypeId.js';
import '../../constants/bidUpdateType.js';
import '../../constants/userAction.js';
import '../../constants/api.js';
import '../../constants/link.js';
import '../../constants/market.js';
import '../../constants/payment.js';
import '../../constants/admin/screenId.js';
import '../../_services/const.js';

const Pill = ({ text, style }) => {
    return (React__default.createElement("div", { style: Object.assign({ padding: `0 10px`, height: getHeightByViewPort(24), width: "fit-content", borderRadius: "4px", backgroundColor: "rgba(155, 155, 155, 0.1)", fontWeight: FONT_WEIGHTS.medium, fontSize: getRemValue(12), lineHeight: getHeightByViewPort(24), color: "rgba(10, 34, 57, 0.6)" }, style) }, text));
};

export { Pill as default };
//# sourceMappingURL=Pill.js.map
